<!--  -->
<template>
  <div>
    
    <news-show :plates="plates" v-if="plates.length>0" />
    <center-model :plates="plates" v-if="plates.length>0"/>
    <exam-center/>
    <course-center/>
    <live-center/>
  </div>
</template>

<script>
//
import CenterModel from "@/components/HomeComs/CenterModel.vue";
import ExamCenter from "@/components/HomeComs/ExamCenter.vue";
import NewsShow from "@/components/HomeComs/NewsShow.vue";
import CourseCenter from "../components/HomeComs/CourseCenter.vue";
import LiveCenter from '../components/HomeComs/LiveCenter.vue';
const rate= window.innerWidth/1240;
export default {
  
  metaInfo: {
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  data() {
    return {};
  },
  props: {
    plates: Array,
  },
    beforeCreate() {
    document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family:Verdana;background: url("/static/images/bg.png");background-repeat: no-repeat;'
      );
  },
  components: { NewsShow, CenterModel, ExamCenter, CourseCenter, LiveCenter },

  mounted() {},

  methods: {},
};
</script>
<style  scoped>
</style>
